// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__3H8i_"};